class AppController
{
	notificationService = null;
	currentPage = null; // esto deberia convertirse en un stack a futuro

	constructor() {

		// Solo se inicializan las variables globales
		this.vars = $('#page-vars').data();
		this.session = $('#page-session').data();
		this.settings = $('#page-settings').data('values');

		// Inicializar el servicio de autenticación
		this.authService = new AuthService();
	}

	async init() {
		try {
			$(document).on('error', 'img[data-fallback]', function() {
				$(this).attr('src', $(this).attr('data-fallback'));
			});

			// Chrome iOS WorkAround. 28/11/2023
			// Hay un bug que por algun motivo no estan disparandose los eventos click de los elementos fuera de pantalla, una vez que toco la pantalla, se hace focus y recien ahi empiezan a funcionar.
			// Con este workaround, ssi primero capturo el touchstart, los clicks se capturan correctamente.
			$('body').on('touchstart', '[data-trigger]', () => {});

			// Descargar e Inicializar librerias adicionales
			FavListHelper.init();

			// El primer bind es para tracking de analytics, se separa del data-trigger para que no haya inconvenientes respecto al stopPropagation que alla por default se ejecuta y aca no.
			$('body').on('click', '[data-track="click"]', async (event) => {
				const target = event.currentTarget;
				this.sendEvent(target);
			});

			$("#themeSelector").on('change', this.handleThemeSelector);

			this.DropdownMultilevel();
			this.loadPlugins($);
			$('a[role="locale"]').on('click', this.handleLocaleSelector);

			// previe el cierre automatico del dropdown sin usar metodos como preventPropagation que afecta otras funcionalidades
			// $('.dropdown[data-auto-close="disabled"]').on('hide.bs.dropdown', ev => !(ev.clickEvent && $(ev.target).has(ev.clickEvent.target).length))
			// Feedback
			let viewCount = parseInt( localStorage.getItem('_viewCount') || 0 ) + 1;
			localStorage.setItem('_viewCount', viewCount);
			let feedback = parseInt( localStorage.getItem('_feedback') || 0 );
			if( viewCount > 6 && feedback == 0 ) {
				localStorage.setItem('_feedback', 1);
			}
			let back2Top = document.getElementById("back-to-top");
			let _publish_btn = document.getElementById("global-publish-btn");
			window.addEventListener('scroll', UtilityHelper.throttle( 100, function(){
				if (document.documentElement.scrollTop > 1000) {
					back2Top.classList.add('show');
					if(_publish_btn) _publish_btn.classList.add('d-none');
				} else {
					back2Top.classList.remove('show');
					if(_publish_btn) _publish_btn.classList.remove('d-none');
				}
			}));


			const news = $('#page-news').data();
			if(news) {
				this.loadNews(news);
			}

			// Inicializar seccion que se esta renderizando
			const page = $("#page").data();
			switch(page.controller) {
				case 'pub': {
					this.currentPage = new PubController(page.pub_id, page.options);
					this.currentPage.init();
					break;
				}

				case 'listing':
					this.currentPage = new ListingController( page.options );
					this.currentPage.init();
					break;

				case 'profile':
					this.currentPage = new ProfileController( page.options );
					this.currentPage.init()
					break;
			}

			// Ejecuto estos binds posteriormente a los relacioandos al modulo.
			// De esta forma podemos capturar un evento especifico en Publication antes de tomarlo globalmente desde aca. (ej reply post)
			$('body').on('click.AppController', '[data-trigger]', this.handleGlobalEvents);

			document.dispatchEvent(new CustomEvent("NOWInitialized"));


			// inicializar notificaciones
			await Library.load(['NotificationService']);
			this.notificationService = new NotificationService();
		} catch (error) {
			ErrorHandler.log(error);
		}
	}

	handleGlobalEvents = async(event) => {

		const target = event.currentTarget;
		// deshabilitar el boton para evitar doble click
		target.disabled = true;
		let laddaButton = null;
		let stopPropagation = true;

		// Por default se hace un stop propagation
		// A menos que se defina el atributo data-allow-propagation
		// O que se haya disparado por el track event y no tenga un trigger
		if(target.dataset.allowPropagation === undefined) {
			stopPropagation = false;
		}

		// Si es tipo button inicializar Ladda
		if(target.tagName === 'BUTTON') {
			if(!target.dataset.style) {
				target.dataset.style = 'zoom-out';
			}
			laddaButton = Ladda.create(target);
		}


		try {
			switch (target.dataset.trigger) {
				case 'Auth.login':
					laddaButton?.start();
					await Library.load(['LoginComponent']);
					await new LoginComponent().init();
					break;

				case 'Auth.register':
					laddaButton?.start();
					await Library.load(['RegisterComponent']);
					await new RegisterComponent().init();
					break;

				case 'Auth.logout':
					laddaButton?.start();
					this.authService.onLogout();
					break;

				case 'Auth.recovery':
					laddaButton?.start();
					await Library.load(['RecoveryComponent']);
					await new RecoveryComponent().init();
					break;

				case 'UploadGallery.init':
					laddaButton?.start();
					await Library.load(['UploadGalleryComponent']);
					await UploadGalleryComponent.init();
					break;

				case 'UploadStory.init':
					laddaButton?.start();
					await Library.load(['UploadStoryComponent']);
					await UploadStoryComponent.init();
					break;

				case 'Global.loadNews':
					laddaButton?.start();
					this.loadNews();
					break;

				case 'Whatsapp.send':
					laddaButton?.start();
					this.sendWhatsapp(target.dataset);
					break;

				case 'Global.copy':
					const tmp = document.createElement('textarea');
					tmp.value = target.dataset.value;
					document.body.appendChild(tmp);
					tmp.select();
					document.execCommand('copy');
					document.body.removeChild(tmp);
					break;


				// Posts Events
				case 'Post.validate':
					laddaButton?.start();
					await Library.load(['PostComponent']);
					var post_id = target.dataset.post_id;
					var post_status = target.dataset.post_status;
					await PostComponent.validate(post_id, post_status).catch(() => {
					});
					break;

				case 'Post.delete':
					laddaButton?.start();
					await Library.load(['PostComponent']);
					var post_id = target.dataset.post_id;
					await PostComponent.delete(post_id).catch(() => {
					});
					break;

				case 'Post.sticky':
					laddaButton?.start();
					await Library.load(['PostComponent']);
					await PostComponent.sticky(target).catch(() => {
					});
					break;

				case 'Post.send':
					laddaButton?.start();
					await Library.load(['PostComponent']);
					var pub_id = target.dataset.pub_id;
					var post_id = target.dataset.post_id;
					await PostComponent.send(pub_id, post_id).catch(() => {
					});
					break;

				default:
					stopPropagation = false;
					break;
			}
		} catch (error) {
			ErrorHandler.log(error);
		} finally {
			if(stopPropagation) {
				event.stopPropagation();
			}
			target.disabled = false
			laddaButton?.stop();
		}

	}

	/**
	 * Funcion para cambiar el locale de la pagina
	 * @param event
	 * @returns {Promise<void>}
	 */
	handleLocaleSelector = async (event) => {
		try {
			event.preventDefault();
			await Library.load(['jsCookie']);
			Cookies.set('locale', event.currentTarget.dataset.lang, { expires: 3650 });
			location.reload();
		} catch(error) {
			ErrorHandler.log(error);
		}
	}
	/**
	 * Funcion para cambiar el theme (light/dark/auto) de la pagina
	 * @param event
	 */
	handleThemeSelector = (event) => {
		event.preventDefault();
		event.stopPropagation();
		//
		const mode = $(event.currentTarget).val();
		//navbar
		const d = new Date();
		d.setTime(d.getTime() + (365*24*60*60*1000));
		let expires = "expires="+ d.toUTCString();
		document.cookie = `theme=${mode}; expires=${expires}; path=/;"`
		$('html').removeClassRegex(/^theme-/).addClass(`theme-${mode}`);
	}

	async load(libraries) {
		await Library.load(libraries);
	}

	async initTask(base, opts) {

		// Function to add swipe functionality on given element
		const swipe = (elem) => {
			// Pixel tolerance to determine if task should be completed or deleted
			let tolerance = 200;

			// Reference to the task list containing all tasks
			let taskList = document.getElementsByClassName('task-list')[0];

			// To track movement during swipe
			let movement;

			// Reference to the part of the task that appears when swiping
			let after = elem.querySelector(".task-right");

			// Function to animate the task sliding out after completion
			const animateCompleted = () => {
				let offset = 900, // Starting position
					step = 10;   // Time for each frame of the animation in milliseconds

				elem.style.marginLeft = offset + 'px';

				// Set an interval to perform the animation
				let animationTime = setInterval(() => {
					if (offset > 0) {
						elem.style.marginLeft = (offset -= 20) + 'px';
					} else {
						clearInterval(animationTime);
					}
				}, step);
			};

			// Function to complete the task
			const completeTask = () => {
				// Update the classes to reflect task completion
				elem.classList.remove('completing');
				elem.classList.add('completed');

				// Reorder the task list so the completed task goes to the end
				taskList.removeChild(elem);
				taskList.appendChild(elem);

				// Slide the task out to signify completion
				animateCompleted();
			};

			// Function to delete the task
			const deleteTask = () => {
				if (opts.onDelete) {
					opts.onDelete(elem);
				}
				// Remove deleting class and remove the element from the DOM
				elem.classList.remove('deleting');
				taskList.removeChild(elem);
			};

			// Function to reset the swipe
			const resetSwipe = () => {
				movement = 0;
				elem.style.marginLeft = movement + 'px';
				elem.isMouseDown = false;
			};

			// Function to remove active classes
			const resetClasses = () => {
				elem.classList.remove('deleting');
				elem.classList.remove('completing');
			};

			// Function to handle mouse movement during swipe
			const handleMouseMove = (e) => {
				if (elem.isMouseDown) {
					if (elem.touchStartX && e.touches) {
						movement = e.touches[0].pageX - elem.touchStartX;
					} else {
						movement += e.movementX;
					}
					// Do not process swipe to the right
					if (movement > 0) return;

					// Apply classes based on swipe distance
					if (movement > tolerance) {
						elem.classList.add('completing');
						movement = tolerance;
					} else if (movement < -tolerance) {
						elem.classList.add('deleting');
						movement = -tolerance;
					} else {
						resetClasses();
					}
					// Move the element based on swipe distance
					elem.style.marginLeft = movement + 'px';

					// Change opacity of the 'after' section based on swipe distance
					after.style.opacity = Math.abs(movement) / tolerance;
				}
			};

			// Function to handle when mouse leaves the element
			const handleMouseOut = (e) => {
				resetSwipe();
				resetClasses();
				elem.touchStartX = null;
				elem.removeEventListener('mousemove', handleMouseMove);
				elem.removeEventListener('touchmove', handleMouseMove);
			};

			// Function to handle end of swipe
			const handleMouseUp = (e) => {
				elem.isMouseDown = false;
				document.removeEventListener('mouseup', handleMouseUp);
				document.removeEventListener('mousemove', handleMouseMove);

				resetSwipe();

				// Check and perform action based on class added during swipe
				if (elem.classList.contains('completing')) {
					completeTask();
				} else if (elem.classList.contains('deleting')) {
					deleteTask();
				}
			};

			// Function to handle start of swipe
			const handleMouseDown = (e) => {
				resetSwipe();
				elem.isMouseDown = true;
				if (e.touches) {
					elem.touchStartX = e.touches[0].pageX;
				}
				document.addEventListener('mousemove', handleMouseMove, false);
				elem.addEventListener('touchmove', handleMouseMove, false);
				document.addEventListener('mouseup', handleMouseUp, false);
			};

			// Adding all necessary event listeners to the given element
			elem.addEventListener('touchstart', handleMouseDown, false);
			elem.addEventListener('touchend', handleMouseUp, false);
			elem.addEventListener('mousedown', handleMouseDown, false);
			elem.addEventListener('click', (ev) => {
				ev.preventDefault();
				if (!ev.target.dataset.trigger && !ev.target.dataset.track) {
					ev.stopPropagation();
				}
			}, false);
			elem.addEventListener('mouseup', handleMouseUp, false);
		}

		// Apply swipe functionality to all tasks
		let tasks = base.getElementsByClassName('task');
		for (let i = 0; i < tasks.length; i++) {
			tasks[i].id = "task_" + i;
			swipe(tasks[i]);
		}
	}

	sendEvent(el) {
		fetch("/api/stats/event", {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(el.dataset)
		});
	}

	sendWhatsapp(dataset) {


		function decodeHTMLEntities(str) {
			var textArea = document.createElement('textarea');
			textArea.innerHTML = str;
			return textArea.value;
		}

		const phone = dataset.whatsappPhone ?? NOW.vars.phones.admin;
		let text = NOW.vars.phones[dataset.whatsappType] ? NOW.vars.phones[dataset.whatsappType] : dataset.whatsappText ?? '';
		text = decodeHTMLEntities(text); // remover el escape
		text = encodeURIComponent(text); // encodear para url

		let link;
		if(UtilityHelper.isMobile()) {
			link = `whatsapp://send?phone=${( NOW.vars.phones[dataset.whatsappChannel] ?? phone).replace(/[^0-9]/g, '')}&text=${text}`;
		}
		else {
			link = `https://api.whatsapp.com/send?phone=${( NOW.vars.phones[dataset.whatsappChannel] ?? phone ).replace(/[^0-9]/g, '')}&text=${ text }`;
		}

		UtilityHelper.openLink(link);

	}

	async sendFeedback(type) {

		const modal = new ModalUi();

		let [$modal] = await Promise.all([
			modal.loadFromServer('feedback', {}),
			Library.load(['dropzone']),
		]);

		modal.render();
	}

	DropdownMultilevel() {

		// guardar posicion del menu emergente, para poder calcular max-height desde css
		$('.dropdown-multilevel').parent().on('shown.bs.dropdown', function(e) {
			const $dropdown = $(this).children('.dropdown-menu')
			const offset = $dropdown.offset();
			const $root = $dropdown.children('.dropdown-level');

			$dropdown.css('--offsetTop', offset.top + 'px').css('--offsetLeft', offset.left + 'px');
			$root.addClass('show');
		});

		// Al cerrar el dropdown
		$('.dropdown-multilevel').parent().on('hidden.bs.dropdown', function(e) {
			$(this).children('.dropdown-multilevel')
				.attr('data-level', 1)
				.css('height', 'auto');
			$(this).children('.dropdown-menu.show').removeClass('show');
		});

		// Al clickear una opcion del dropdown
		$('.dropdown-menu').on('click', '[data-toggle="dropdown"]', function(e) {
			e.stopPropagation();

			// Desplegar el menu
			let $target = $(this).next(".dropdown-menu");

			let container = $(this).closest('.dropdown-multilevel');
			container.find('.dropdown-menu.show').removeClass('show');
			container.find('.dropdown-level.show').removeClass('show');
			$target.addClass('show'); // tiene que ir aca, para que obtenga el height correcto.
			container.attr('data-level', 2);
			container.css('height', $target.children('.dropdown-content').height() + 16); // 16 = padding-top + padding-bottom

			return false;
		});

		// Al volver a un nivel superior.
		$('.dropdown-menu .dropdown-back').on('click', function(e) {
			e.stopPropagation();

			let levels = $(this).parents('.dropdown-level');

			$(this).closest('.dropdown-menu.show').removeClass('show');
			$(this).closest('.dropdown-multilevel').attr('data-level', (levels.length - 1));
			$(this).closest('.dropdown-multilevel').children('.dropdown-level').addClass('show');

			$(this).closest('.dropdown-multilevel').css('height', 'auto');

		});
	}

	async loadPlugins(base) {
		await Promise.all([
			PluginsHandler.load(base),
		]);
		$(base).find('.card__loading').removeClass('card__loading');
	}

	/**
	 * La función loadNews es una función asíncrona que se utiliza para cargar y mostrar noticias en una ventana modal. Aquí hay algunos comentarios sobre su funcionamiento:
	 * Acepta un parámetro opcional llamado data que contiene información sobre las noticias a cargar. Si este parámetro no se proporciona, la función llamará a la función fetchNews para obtener las noticias.
	 **/
	async loadNews(data) {

		// Función asincrónica para cargar las noticias mediante una llamada a la API
		async function fetchNews(params = {}) {
			let response = await fetch(`/api/fetch/news` + '?' + new URLSearchParams(params));
			return await response.json();
		}

		// Función asincrónica para añadir las noticias cargadas a la ventana modal
		async function appendNews($modal, data) {
			// Si el objeto de datos incluye la propiedad `empty`, entonces se agrega el mensaje de vacío
			if(data.empty) {
				$modal.find('.modal-body').append(data.empty);
				$modal.find('button[role="loadMore"]').remove();
				return;
			}

			// Si la propiedad `show` es verdadera, entonces se renderiza el contenido de noticias mediante Twig
			if(data.show == true) {
				let newsContent = Twig.twig({
					data: `{% for row in list %}<div class="ql-editor" data-news_date="{{row.news_date}}"><small class="d-block">{{row.news_date_formatted}}</small>{{row.news_content}}</div><hr>{% endfor %}`
				}).render(data);
				$modal.find('.modal-body').append(newsContent);
			}

			// Si la propiedad `show` es falsa o el número de elementos en la lista es menor que 3, se elimina el botón de cargar más noticias
			if(data.show == false || data.list.length < 3) {
				$modal.find('button[role="loadMore"]').remove();
			}
		}

		const modal = new ModalUi();

		// Se llama a `modal.loadFromTemplate` y `Library.load` simultáneamente y se espera a que ambas se completen antes de continuar
		let [$modal] = await Promise.all([
			modal.loadFromTemplate('news-modal.tpl'),  // Analiza el archivo de plantilla de la ventana modal de noticias
			Library.load(['quill']),  // Carga las bibliotecas necesarias para las noticias
		]);

		modal.render();  // Renderiza la ventana modal

		// Si no se proporciona el objeto de datos, se llama a `fetchNews` sin parámetros
		// Esto sucede cuando se abre las noticias desde el menú
		if(data == undefined) {
			data = await fetchNews({
				news_country: NOW.vars.country_id || null,
			});
			if(!data.show) {
				await PhrasesService.load(['NEWS_EMPTY']);
				data.empty = PhrasesService.get('NEWS_EMPTY');
			}
		}

		appendNews($modal, data);  // Añade las noticias a la ventana modal

		// Cuando se hace clic en el botón de cargar más noticias, se llama a `fetchNews` con el parámetro `news_date` y `news_country`, y se agrega el resultado a la ventana modal
		$modal.find('button[role="loadMore"]').click(async function() {
			let value = $modal.find('.ql-editor[data-news_date]').last().attr('data-news_date');
			data = await fetchNews({
				news_date: value,
				news_country: NOW.vars.country_id,
			});
			appendNews($modal, data);
		});
	}

	initGoogleServices() {
		// Buscar el script de Google Tag Manager
		const gtagScript = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
		if (gtagScript) {
			const gtagId = gtagScript.getAttribute('gtag');
			if (gtagId) {
				window.dataLayer = window.dataLayer || [];
				function gtag() { dataLayer.push(arguments); }
				gtag('js', new Date());
				gtag('config', gtagId);
				console.log(`Google Tag Manager cargado con el ID: ${gtagId}`);
			}
		}

		// Buscar el script de Google Analytics
		const gaScript = document.querySelector('script[src*="google-analytics.com/analytics.js"]');
		if (gaScript) {
			const gaId = gaScript.getAttribute('ga');
			if (gaId) {
				window.ga = window.ga || function () { (ga.q = ga.q || []).push(arguments); };
				ga.l = +new Date;
				ga('create', gaId, 'auto');
				ga('send', 'pageview');
				console.log(`Google Analytics cargado con el ID: ${gaId}`);
			}
		}
	}
}

document.addEventListener("DOMContentLoaded", function(event) {
	window.Library.addInlineDefines();
	window.Cache = {};
	// Inicializar la aplicación y asignarla a la variable global NOW
	window.NOW = new AppController();
	NOW.init();
	NOW.initGoogleServices();
});